import { useQuery } from "@tanstack/react-query";
import { fetchDocuments } from "../api/rfx-document-api";
import { fetchTemplateDocuments } from "../api/rfx-template-document-api";

/*
 * Query key includes the `isTemplate` flag so RFx and Template caches never
 * collide for the same numeric id (an RFQ #42 and a template #42 are
 * different rows in different tables).
 */
export const RFX_DOCUMENTS_QUERY_KEY = (id: number, isTemplate = false) =>
  ["rfx-documents", { id, isTemplate }] as const;

export const useRfxDocuments = (
  id: number,
  { isTemplate = false }: { isTemplate?: boolean } = {}
) => {
  // `isFetching` (vs `isLoading`) is intentionally surfaced via the default
  // useQuery return so the manager can show a spinner during refetches
  // triggered after an upload completes, not just on first load.
  return useQuery({
    queryKey: RFX_DOCUMENTS_QUERY_KEY(id, isTemplate),
    queryFn: () => (isTemplate ? fetchTemplateDocuments(id) : fetchDocuments(id)),
    enabled: id > 0,
  });
};
